export default __webpack_public_path__ + "static/media/hotel_4.987e23de.png";